
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const services = [
    { name: 'Körüklü Tente', slug: 'koruklu-tente' },
    { name: 'Mafsallı Tente', slug: 'mafsalli-tente' },
    { name: 'Otomatik Pergola', slug: 'otomatik-pergola' },
    { name: 'Bioklimatik Pergola', slug: 'bioklimatik-pergola' },
    { name: 'Zip Perde', slug: 'zip-perde' },
    { name: 'Şeffaf Stor', slug: 'seffaf-stor' },
    { name: 'Fransız Tente', slug: 'fransiz-tente' },
    { name: 'Kasetli Tente', slug: 'kasetli-tente' },
    { name: 'Karpuz Tente', slug: 'karpuz-tente' },
    { name: 'T Modül Tente', slug: 't-modul-tente' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <nav className="mx-auto px-4 py-2" aria-label="Ana navigasyon">
          <div className="flex items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-2 cursor-pointer group">
              <div className="w-20 h-20 md:w-32 md:h-32 flex items-center justify-center flex-shrink-0">
                <img 
                  src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/6421f073c7f28abfe60c7a826ab5b84a.png" 
                  alt="Bursa Tente Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="block">
                <div className="text-base md:text-2xl font-bold text-primary group-hover:text-secondary transition-colors whitespace-nowrap">
                  Bursa Tente
                </div>
                <div className="text-[10px] md:text-xs text-gray-600 whitespace-nowrap">
                  Modern Tente & Pergola Sistemleri
                </div>
              </div>
            </Link>

            {/* Desktop Menu */}
            <ul className="hidden lg:flex items-center gap-8" role="menubar">
              <li role="none">
                <Link
                  to="/"
                  className="text-sm font-medium text-primary hover:text-secondary transition-colors whitespace-nowrap cursor-pointer"
                  role="menuitem"
                >
                  Anasayfa
                </Link>
              </li>
              <li role="none">
                <Link
                  to="/hakkimizda"
                  className="text-sm font-medium text-primary hover:text-secondary transition-colors whitespace-nowrap cursor-pointer"
                  role="menuitem"
                >
                  Hakkımızda
                </Link>
              </li>
              <li role="none" className="relative group">
                <button
                  className="text-sm font-medium text-primary hover:text-secondary transition-colors flex items-center gap-1 whitespace-nowrap"
                  aria-label="Hizmetler menüsü"
                  onClick={() => setIsServicesOpen(!isServicesOpen)}
                >
                  Hizmetler
                  <i className="ri-arrow-down-s-line"></i>
                </button>
                <div
                  className="absolute top-full left-0 mt-2 bg-white rounded-lg shadow-xl py-4 w-64 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200"
                  role="menu"
                >
                  {services.map((service) => (
                    <Link
                      key={service.slug}
                      to={`/hizmetler/${service.slug}`}
                      className="block px-6 py-2 text-sm text-gray-700 hover:bg-secondary/10 hover:text-secondary transition-colors cursor-pointer"
                      role="menuitem"
                    >
                      {service.name}
                    </Link>
                  ))}
                </div>
              </li>
              <li role="none">
                <Link
                  to="/yorumlar"
                  className="text-sm font-medium text-primary hover:text-secondary transition-colors whitespace-nowrap cursor-pointer"
                  role="menuitem"
                >
                  Müşteri Yorumları
                </Link>
              </li>
              <li role="none">
                <Link
                  to="/iletisim"
                  className="text-sm font-medium text-primary hover:text-secondary transition-colors whitespace-nowrap cursor-pointer"
                  role="menuitem"
                >
                  İletişim
                </Link>
              </li>
            </ul>

            {/* Desktop Actions */}
            <div className="hidden lg:flex items-center gap-4">
              <a
                href="tel:+905421821925"
                className="flex items-center gap-2 text-sm font-medium text-primary hover:text-secondary transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-lg"></i>
                +90 542 182 19 25
              </a>
              <a
                href="https://wa.me/905421821925?text=Merhaba,%20tente%20ve%20pergola%20sistemleri%20hakkında%20bilgi%20almak%20istiyorum"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-secondary text-white px-6 py-2.5 rounded-full text-sm font-bold hover:bg-secondary/90 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill mr-2"></i>
                Hemen Teklif Al
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden w-10 h-10 flex items-center justify-center text-primary hover:text-secondary transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Menüyü aç"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
            <ul className="py-4 px-6 space-y-4">
              <li>
                <Link
                  to="/"
                  className="block text-sm font-medium text-primary hover:text-secondary transition-colors cursor-pointer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link
                  to="/hakkimizda"
                  className="block text-sm font-medium text-primary hover:text-secondary transition-colors cursor-pointer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Hakkımızda
                </Link>
              </li>
              <li>
                <button
                  className="w-full text-left text-sm font-medium text-primary hover:text-secondary transition-colors flex items-center justify-between"
                  onClick={() => setIsServicesOpen(!isServicesOpen)}
                >
                  Hizmetler
                  <i className={`ri-arrow-${isServicesOpen ? 'up' : 'down'}-s-line`}></i>
                </button>
                {isServicesOpen && (
                  <ul className="mt-2 ml-4 space-y-2">
                    {services.map((service) => (
                      <li key={service.slug}>
                        <Link
                          to={`/hizmetler/${service.slug}`}
                          className="block text-sm text-gray-700 hover:text-secondary transition-colors cursor-pointer"
                          onClick={() => {
                            setIsMobileMenuOpen(false);
                            setIsServicesOpen(false);
                          }}
                        >
                          {service.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              <li>
                <Link
                  to="/yorumlar"
                  className="block text-sm font-medium text-primary hover:text-secondary transition-colors cursor-pointer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Müşteri Yorumları
                </Link>
              </li>
              <li>
                <Link
                  to="/iletisim"
                  className="block text-sm font-medium text-primary hover:text-secondary transition-colors cursor-pointer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  İletişim
                </Link>
              </li>
              <li className="pt-4 border-t border-gray-200">
                <a
                  href="tel:+905421821925"
                  className="flex items-center gap-2 text-sm font-medium text-primary hover:text-secondary transition-colors cursor-pointer"
                >
                  <i className="ri-phone-fill text-lg"></i>
                  +90 542 182 19 25
                </a>
              </li>
            </ul>
          </div>
        )}
      </header>
    </>
  );
}
